// extracted by mini-css-extract-plugin
export default {"cancelIcon":"ErrorSnackbar_cancelIcon__pCRR2"};